import { useEffect } from 'react';

import { isTextEntryTarget } from './components/MapEditorCanvas';

export default function useUndoRedoShortcuts(
    onUndo: () => void,
    onRedo: () => void,
    isEnabled: boolean
) {
    useEffect(() => {
        if (!isEnabled) return undefined;
        function handleKeyDown(e: KeyboardEvent) {
            const isDialogOpen = document.querySelector('[role="dialog"]') !== null;
            if (isDialogOpen || isTextEntryTarget(e.target) || !(e.ctrlKey || e.metaKey)) return;
            const key = e.key.toLowerCase();
            if (key === 'y' || (key === 'z' && e.shiftKey)) {
                e.preventDefault();
                onRedo();
            } else if (key === 'z') {
                e.preventDefault();
                onUndo();
            }
        }
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    });
}
